import { TabContext, TabList, TabPanel } from "@mui/lab";
import { 
  Box, 
  Card, 
  CardContent, 
  Chip, 
  Container, 
  Grid, 
  Link, 
  Paper, 
  Tab, 
  Typography,
  useTheme,
  alpha
} from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import SchoolIcon from '@mui/icons-material/School';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../common/layouts/dashboard";
import { useAppDispatch } from "../../core/hooks/useStore";
import { homeSlice } from "../home";

const Training = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  
  const training = [
    {
      name: "Basic Training",
      icon: <SchoolIcon />,
      description: "Learn the fundamentals of Wordform AI and start creating content",
      k: 0,
      slug: "basic",
      videos: [
        {
          title: "Welcome to the Beginner Training!",
          description: "Brandon walks you through the basics of the Wordform AI platform and what we will cover in this training.",
          vimeoId: "940819037",
          hash: "101654244c",
          duration: "5 min"
        },
        {
          title: "Niche Selection",
          description: "Learn what makes a good niche and how to use AI to quickly find profitable niches.",
          vimeoId: "940819684",
          hash: "c57334be63",
          duration: "63 min",
          resources: [
            { name: "Niche Pig", url: "https://wordform.ai/niche-generator/" },
            { name: "Topic Pig", url: "https://wordform.ai/keyword-generator/" },
            { name: "Headline Pig", url: "https://wordform.ai/headline-generator/" }
          ]
        },
        {
          title: "Content Creation (Part 1)",
          description: "Get started creating content in Wordform AI - Part 1.",
          vimeoId: "940820597",
          hash: "bf1efff4ea",
          duration: "6 min"
        },
        {
          title: "Content Creation (Part 2)",
          description: "Continue learning content creation in Wordform AI - Part 2.",
          vimeoId: "940820662",
          hash: "fab6c68e36",
          duration: "15 min"
        },
        {
          title: "Content Creation (Part 3)",
          description: "Advanced content creation techniques - Part 3.",
          vimeoId: "940820943",
          hash: "f761a2a013",
          duration: "5 min"
        },
        {
          title: "Google AdSense",
          description: "Learn how to monetize your site with Google Adsense.",
          vimeoId: "940821023",
          hash: "09e4409177",
          duration: "3 min",
          resources: [
            { name: "Google Adsense", url: "https://adsense.google.com/start/" }
          ]
        },
        {
          title: "Website Flipping",
          description: "Discover how to flip websites for a profit on sites like Flippa.",
          vimeoId: "940821105",
          hash: "0d8e432436",
          duration: "4 min",
          resources: [
            { name: "Flippa", url: "https://flippa.com/" }
          ]
        },
        {
          title: "Affiliate Marketing",
          description: "Master using Wordform AI for affiliate marketing.",
          vimeoId: "940821203",
          hash: "95bda41dac",
          duration: "4 min",
          resources: [
            { name: "Clickbank", url: "https://www.clickbank.com/" }
          ]
        },
        {
          title: "Tracking Your Results",
          description: "Learn how to track your results over time.",
          vimeoId: "940821386",
          hash: "4f5bb04811",
          duration: "10 min"
        },
        {
          title: "Conclusion",
          description: "Wrapping up the beginner training for Wordform AI.",
          vimeoId: "940821557",
          hash: "8093d1d66d",
          duration: "6 min"
        }
      ]
    },
    {
      name: "Invisible Influencer",
      icon: <EmojiEventsIcon />,
      description: "Advanced strategies for social media and affiliate marketing",
      k: 1,
      slug: "invisible-influencer",
      videos: [
        {
          title: "Training Video 1 - Chris Munch",
          description: "Social Advertorial System - Lesson 1",
          vimeoId: "1021629105",
          badge: "0",
          duration: "117 min",
          resources: [
            { name: "Affiliate Programs Spreadsheet", url: "https://docs.google.com/spreadsheets/d/1858HdKKYviubUSoZBxZwJB76CyBQ15zIHiPwn4kz8yo/edit?usp=sharing" },
            { name: "Affiliate Application Template", url: "https://docs.google.com/document/d/1D0gSERrtglM3qYS-c5oBKaQ_LUlN2rrRiFgjcbnEhE0/edit?usp=sharing" }
          ]
        },
        {
          title: "Training Video 2 - Stewart Vickers",
          description: "Social Advertorial System - Lesson 2",
          vimeoId: "1021767101",
          badge: "0",
          duration: "49 min"
        },
        {
          title: "Training Video 3 - Agency",
          description: "Learn how to run an agency with Wordform AI",
          vimeoId: "1044256223",
          badge: "0",
          duration: "123 min",
          resources: [
            { name: "Blog Content Planning Manual", url: "https://go.wordform.ai/blogcontentplanning" },
            { name: "Questions to ask clients", url: "https://go.wordform.ai/questionstoask" },
            { name: "DFY Sales Page", url: "https://go.wordform.ai/dfyagencysalespage" }
          ]
        }
      ]
    },
    {
      name: "Bonuses",
      icon: <CardGiftcardIcon />,
      description: "Exclusive bonuses included with your subscription",
      k: 2,
      slug: "bonuses",
      bonuses: [
        {
          title: "Over-the-Shoulder Training",
          description: "Available within Training > Beginner Training section"
        },
        {
          title: "Live Training",
          description: "Previous live trainings and upcoming sessions",
          link: { text: "Watch Replays", url: "https://wordform.ai/replay" }
        },
        {
          title: "Five Website Templates",
          description: "Ready-to-install professional website templates",
          templates: [
            {
              name: "Home Decor Template",
              image: "https://moneysitefactory.com/wp-content/uploads/2021/08/YRj7AUP.png",
              downloadUrl: "https://drive.google.com/uc?export=download&id=1F0I-QJVQQarC_XXWP7bKVk5UtDsdyelK"
            },
            {
              name: "Business Template",
              image: "https://moneysitefactory.com/wp-content/uploads/2021/08/egixD2G.png",
              downloadUrl: "https://drive.google.com/uc?export=download&id=1qvCP-QX-Nc8l7FP2YS9OTFak04SimFyD"
            },
            {
              name: "Fashion Template",
              image: "https://moneysitefactory.com/wp-content/uploads/2021/08/zXuPQVv.png",
              downloadUrl: "https://drive.google.com/uc?export=download&id=1-GZ2Es9XUBUhtaVnEdB9OA9PAWrwMp9U"
            },
            {
              name: "Investing Template",
              image: "https://moneysitefactory.com/wp-content/uploads/2021/08/quBS5Us.png",
              downloadUrl: "https://drive.google.com/uc?export=download&id=1nccRSQo3qP7Obi6d1-bLSdisYHH6Ju7g"
            },
            {
              name: "Pets Template",
              image: "https://moneysitefactory.com/wp-content/uploads/2021/08/NfqJ915.png",
              downloadUrl: "https://drive.google.com/uc?export=download&id=1autOUQgM7fqUhi7a61pjP2guvybXQtVb"
            }
          ],
          setupVideo: "585642735",
          credentials: {
            username: "admin",
            password: "Vk1x@q!GS0ytHiWn40KFWDJy"
          }
        },
        {
          title: "Monetization Blueprint",
          description: "Step-by-step blueprint for turning clicks into cash",
          link: { 
            text: "Download PDF", 
            url: "https://docs.google.com/document/d/1kFwlXWEPTsNa3g8Q_hSpK1u7DG3orOOU/edit?usp=share_link&ouid=108559562515642288562&rtpof=true&sd=true" 
          }
        }
      ]
    }
  ];

  useEffect(() => {
    dispatch(homeSlice.actions.setActiveMenu("training"));
  }, [dispatch]);

  // Initialize tab based on URL parameter
  const getInitialTab = () => {
    const pathSegments = location.pathname.split('/');
    const urlTab = pathSegments[pathSegments.length - 1];
    
    // Find the matching section by slug
    const sectionIndex = training.findIndex(section => section.slug === urlTab);
    if (sectionIndex !== -1) {
      return sectionIndex.toString();
    }
    
    // Default to first tab if no match or if it's just /training
    return "0";
  };

  const [tab, setTab] = useState<string>(getInitialTab());

  useEffect(() => {
    document.title = "Wordform AI - Training";
  }, []);

  // Handle URL changes and redirects
  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const currentTab = pathSegments[pathSegments.length - 1];
    const hash = location.hash.slice(1); // Remove the # symbol
    
    // If we're on /training/basic with any hash, redirect to /training/{hash-value}
    if (currentTab === 'basic' && hash) {
      navigate(`/training/${hash}`, { replace: true });
      return;
    }
    
    // Set the correct tab based on the URL
    const sectionIndex = training.findIndex(section => section.slug === currentTab);
    if (sectionIndex !== -1) {
      setTab(sectionIndex.toString());
    }
  }, [location.hash, location.pathname, navigate]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
    // Update URL to use path segments instead of hash
    const section = training[parseInt(newValue)];
    if (section?.slug) {
      navigate(`/training/${section.slug}`, { replace: true });
    }
  };

  const VideoCard = ({ video }: { video: any }) => (
    <Card 
      sx={{ 
        height: '100%',
        transition: 'all 0.3s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.shadows[8]
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
          <PlayCircleOutlineIcon 
            sx={{ 
              fontSize: 40, 
              color: theme.palette.primary.main,
              mr: 2
            }} 
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              {video.title}
            </Typography>
            {video.duration && (
              <Chip 
                label={video.duration} 
                size="small" 
                sx={{ mb: 1 }}
              />
            )}
          </Box>
        </Box>
        
        <Typography variant="body2" color="text.secondary" paragraph>
          {video.description}
        </Typography>

        <Box sx={{ position: 'relative', paddingTop: '56.25%', mb: 2 }}>
          <iframe
            src={
              video.badge !== undefined 
                ? `https://player.vimeo.com/video/${video.vimeoId}?badge=${video.badge}&autopause=0&player_id=0&app_id=58479`
                : `https://player.vimeo.com/video/${video.vimeoId}?h=${video.hash}&controls=1&autopause=0&player_id=0&app_id=58479`
            }
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '8px'
            }}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            frameBorder="0"
            title={video.title}
          />
        </Box>

        {video.resources && video.resources.length > 0 && (
          <Box>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
              Resources:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {video.resources.map((resource: any, idx: number) => (
                <Link
                  key={idx}
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  <Chip
                    label={resource.name}
                    size="small"
                    clickable
                    color="primary"
                    variant="outlined"
                  />
                </Link>
              ))}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );

  const BonusCard = ({ bonus, index }: { bonus: any, index: number }) => {
    const getBonusIcon = (index: number) => {
      const icons = [
        '🎓', // Training
        '📺', // Live Sessions
        '🎨', // Templates
        '💰'  // Monetization
      ];
      return icons[index] || '🎁';
    };

    return (
      <Card 
        elevation={1}
        sx={{ 
          mb: 3,
          overflow: 'visible',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          '&:hover': {
            boxShadow: theme.shadows[4],
            borderColor: alpha(theme.palette.primary.main, 0.2)
          },
          transition: 'all 0.3s'
        }}
      >
        <Box 
          sx={{ 
            p: 3,
            background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
            borderBottom: `1px solid ${theme.palette.divider}`
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="h3">
              {getBonusIcon(index)}
            </Typography>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                Bonus #{index + 1}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {bonus.title}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            {bonus.description}
          </Typography>
          {bonus.link && (
            <Box sx={{ mt: 2 }}>
              <Link 
                href={bonus.link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ textDecoration: 'none' }}
              >
                <Chip
                  label={bonus.link.text}
                  color="primary"
                  variant="filled"
                  clickable
                  sx={{ fontWeight: 600 }}
                />
              </Link>
            </Box>
          )}
        </Box>

        {bonus.templates && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📦</span> Website Templates Collection
              </Typography>
              <Grid container spacing={2}>
                {bonus.templates.map((template: any, idx: number) => (
                  <Grid item xs={12} sm={6} lg={4} key={idx}>
                    <Paper 
                      elevation={0}
                      sx={{ 
                        p: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        height: '100%',
                        transition: 'all 0.3s',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: theme.shadows[2],
                          borderColor: theme.palette.primary.main
                        }
                      }}
                    >
                      <Box sx={{ textAlign: 'center' }}>
                        <Box 
                          sx={{ 
                            mb: 2, 
                            p: 2, 
                            bgcolor: alpha(theme.palette.grey[100], 0.5),
                            borderRadius: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 150
                          }}
                        >
                          <img 
                            src={template.image} 
                            alt={template.name}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%',
                              height: 'auto',
                              borderRadius: '4px',
                              objectFit: 'contain'
                            }}
                          />
                        </Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                          {template.name}
                        </Typography>
                        <Link
                          href={template.downloadUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ textDecoration: 'none' }}
                        >
                          <Chip
                            label="⬇ Download Template"
                            color="primary"
                            variant="outlined"
                            clickable
                            sx={{ fontWeight: 500 }}
                          />
                        </Link>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
            
            {bonus.setupVideo && (
              <Box 
                sx={{ 
                  mt: 4, 
                  p: 3, 
                  bgcolor: alpha(theme.palette.info.main, 0.05),
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`
                }}
              >
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>🎥</span> How to Install Templates
                </Typography>
                <Box sx={{ position: 'relative', paddingTop: '56.25%', mt: 2, borderRadius: 2, overflow: 'hidden' }}>
                  <iframe
                    src={`https://player.vimeo.com/video/${bonus.setupVideo}?controls=1&autopause=0&player_id=0&app_id=58479`}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      border: 'none'
                    }}
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                    frameBorder="0"
                    title="Setup Tutorial"
                  />
                </Box>
              </Box>
            )}

            {bonus.credentials && (
              <Box 
                sx={{ 
                  mt: 3, 
                  p: 3, 
                  bgcolor: alpha(theme.palette.warning.main, 0.05),
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`
                }}
              >
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>🔐</span> Default Login Credentials
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Use these credentials to access the admin panel of your templates:
                </Typography>
                <Paper 
                  sx={{ 
                    p: 2, 
                    bgcolor: 'background.paper',
                    border: `1px solid ${theme.palette.divider}`
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">USERNAME</Typography>
                      <Typography variant="body1" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
                        {bonus.credentials.username}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">PASSWORD</Typography>
                      <Typography variant="body1" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
                        {bonus.credentials.password}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                  💡 Note: These templates include demo content that you can delete and replace with content from Wordform AI.
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </Card>
    );
  };

  return (
    <DashboardLayout active={"training"} name="Training">
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            Training Center
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Master Wordform AI with our comprehensive training materials
          </Typography>
        </Box>

        <TabContext value={tab}>
          <Paper sx={{ mb: 3 }}>
            <TabList 
              onChange={handleChange}
              variant="fullWidth"
              sx={{
                '& .MuiTab-root': {
                  minHeight: '64px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 500
                }
              }}
            >
              {training.map((t: any, k: number) => (
                <Tab 
                  key={k}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {t.icon}
                      <span>{t.name}</span>
                    </Box>
                  } 
                  value={k.toString()} 
                />
              ))}
            </TabList>
          </Paper>

          {training.map((section: any, k: number) => (
            <TabPanel key={k} value={k.toString()} sx={{ px: 0 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                  {section.name}
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  {section.description}
                </Typography>
              </Box>

              {section.videos && (
                <Grid container spacing={3}>
                  {section.videos.map((video: any, idx: number) => (
                    <Grid item xs={12} md={6} key={idx}>
                      <VideoCard video={video} />
                    </Grid>
                  ))}
                </Grid>
              )}

              {section.bonuses && (
                <Box>
                  {section.bonuses.map((bonus: any, idx: number) => (
                    <BonusCard key={idx} bonus={bonus} index={idx} />
                  ))}
                </Box>
              )}
            </TabPanel>
          ))}
        </TabContext>
      </Container>
    </DashboardLayout>
  );
};

export default Training;